import $  from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import AdditionalResourcesComponent from './app';
import './styles.scss';

export default class AdditionalResourcesModule {
  constructor(config, $modules) {
    $modules.each((index, el)=>{
      let $el = $(el);
      if($el.hasClass('module-loaded')) {
        return;
      }
      let configId = $el.data('config-id');
      let moduleData = config.find( (data) => {
        return data['config-id']==configId;
      });
      if(!moduleData) return;
    	let props = moduleData;
      ReactDOM.render(React.createElement(AdditionalResourcesComponent, props), el);
      $el.addClass('module-loaded');
    });
  }
}

AdditionalResourcesModule.selector = '[data-module="AdditionalResources"]';
AdditionalResourcesModule.init = function(config,$modules){
  $modules = $(AdditionalResourcesModule.selector);
  if($modules.length>0) {
    new AdditionalResourcesModule(config,$modules);
  }
}



// WEBPACK FOOTER //
// ./src/app/additional-resources/index.js